module.exports = {
  findPwd: {
    find: 'Reset Your Password',
    userName: 'Phone number or e-mail address',
    error_userName_1: 'Please input phone number or e-mail address',
    error_userName_2: 'This phone number is not bind to any StarryHub account yet',
    error_userName_3: 'This e-mail address is not bind to any StarryHub account yet',
    get_code: 'Obtain',
    get_code_tip: 'Click to send verification code',
    get_code_tip_re: 's resend',
    code: 'Verification Code',
    error_code_1: 'Please input verification code',
    error_code_2: '5 verification codes have been sent. Reach quantity limit today.',
    error_code_3: 'Incorrect verification code',
    error_code_4: 'SMS verification code sent. It\'s valid for 10 minutes',
    error_code_5: 'Request for SMS verification code is too frequent. Please try again later',
    error_phone: 'Please enter the correct account',
    next: 'Continue',
    input_password: 'Password',
    repeat_new_password: 'Confirm password',
    new_password_error: 'The passwords are not consistent.',
    submit_new_password: 'Submit',
    success_relogin: 'New password set successfully',
    button_relogin: 'Log In',
    password_set: '8-20 digits and letters combination',
    account_info: 'Account Info',
    current_account: 'Current Account',
    change_password: 'Change Password',
    phone_find: 'Retrieve account password through mobile phone or e-mail',
    not_bind_starryHub: 'Not bind to any StarryHub account yet',
    expired: 'Expired',
    account_type: 'Select Account Type',
    starryHub_account: 'StarryHub Account',
    czur_cloud_account: 'CZUR Cloud Account'
  },
  tips: {
    timeout: 'Request timed out!',
    internalError: 'Server internal error！',
    networkError: 'Network connection error!',
    connectError: 'Connection error(',
    errorStatus: 'Request error(400)'
  },
  index: {
    loginText: 'CZUR Cloud',
    accountNumber: 'CZUR Account/Meeting Account',
    password: 'Password',
    forgetPwd: 'Forgot Password',
    register: 'Sign Up',
    errorTip: 'User name or password incorrect',
    selectFunction: 'Please select corresponding function',
    unactivated: 'The account is not activated',
    notebook: 'Notebook',
    mobileTip: 'This webpage is designed and developed for PC users only.',
    youCan: 'You can:',
    mobileTextOne: 'download CZUR APP to your smart phone',
    mobileTextTwo: 'or use browser in PC to visit this webpage.',
    downloadApp: 'Download APP',
    countryError: 'This account is not registered in this country/area. Would you like to switch to the registration country/area to get corresponding service?',
    countryGo: 'Yes'
  },
  list: {
    noFile: 'No file',
    time: 'Time',
    category: 'Category',
    accountCenter: 'Account Center',
    logOut: 'Log out',
    thisday: 'This day',
    items: 'items',
    total: 'Total',
    feedback: 'Suggestion & Feedback',
    used: 'Used',
    back: 'Back',
    loading: 'Loading...',
    loaded: 'Loaded',
    feedbackPlaceholder: 'Please share your feedback (less than 600 bytes)',
    submit: 'Submit',
    cancel: 'Cancel',
    feedbackSuccess: 'Submited!',
    label: 'Label',
    empty: 'Empty'
  },
  player: {
    flatSinglePage: 'Single',
    curvePage: 'Books',
    color: 'Color',
    grayscale: 'Grayscale',
    bw: 'B&W',
    pattern: 'Pattern',
    autoEnhance: 'Auto Enhance',
    copyToClipboard: 'Coped to clipboard',
    noOcrResult: 'No OCR result',
    ocrTip: 'Please use handwriting OCR function in the CZUR APP.'
  },
  operation: {
    selected: 'Selected',
    selectAllLoaded: 'Select All',
    deselectAll: 'Deselect All',
    moveFiles: 'Move files',
    share: 'Share',
    exportPDF: 'Export PDF',
    download: 'Download',
    delete: 'Delete',
    moveToFolder: 'Move to Folder',
    rename: 'Rename',
    confirm: 'Confirm',
    msg: 'Message',
    moveFilesSuccess: 'Files moved.',
    floderName: 'Please name the folder',
    shareTimeLimit: 'Share Link Expiration',
    hours: 'hours',
    days: 'days',
    createLink: 'Create Link',
    shareLink: 'Share Link',
    password: 'Password',
    copy: 'Copy',
    createPDF: 'Create PDF',
    pdfName: 'Please name the PDF',
    pdfSet: 'PDF Setting',
    pdfSize: 'PDF Size',
    autoAdjustment: 'Auto',
    pdfDirection: 'PDF Orientation',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    pdfQuality: 'PDF Quality',
    standard: 'Standard',
    maximum: 'Optimal',
    pdfCreated: 'PDF is Created',
    done: 'Done'
  },
  share: {
    shareLink: 'CZUR ET Share Link: ',
    expire: ' Expiration time: ',
    shared: 'Shared by ',
    enterPassword: 'Please Enter the Password',
    wrongPassword: 'Wrong password',
    fileExpired: 'The file is expired',
    fileDelete: 'The file is deleted',
    package: 'Packing',
    shareNotebookLink: 'CZUR Notebook Share Link: '
  },
  device: {
    deviceList: 'Device List',
    noDevice: 'No device',
    apply: 'Apply',
    using: 'In use',
    bindDeviceTips: 'Please use CZUR APP to scan the QR code on device label, then add and bind ET series model.',
    gotIt: 'I got it',
    isUsingDevice: ' is using the device',
    unbindDevice: 'Unbind',
    searchAccount: 'Search CZUR Account',
    searchMember: 'Search',
    transferAdministrator: 'Transfer Administrator Rights',
    deleteMember: 'Remove Member',
    shareDevice: 'Share Device',
    shareDeviceTips: 'If you share this device, other users can use the device by scanning the QR code on the device label and you are still the device administrator',
    noMember: 'No other members',
    unbindDeviceTips: 'When the scanner is unbind from this account, all other members (you shared this scanner to) cannot use the scanner any more. The account and data will be reserved in the CZUR Cloud. The unbinding takes effect after you  restart the scanner.',
    unbind: 'Unbind',
    noAccount: 'Account does not exist',
    addMember: 'Add',
    administrator: 'Administrator',
    added: 'Added',
    cancelTransfer: 'Cancel Transfer',
    conformTransfer: 'Conform Transfer',
    ifTransferadministrator: 'Transfer administrator rights to ',
    cancelDelete: 'Undelete',
    confirmDelete: 'Delete',
    ifDeleteMember: 'Delete member ',
    and: ' and ',
    others: ' others',
    needFirmwareUpgrade: 'Upgrade',
    statement: 'Statement',
    upgradeTest: 'Because of the cloud service upgrade, your ET firmware also needs to be upgraded.',
    upgradeTestOne: '1. Turn on the ET and connect it to the computer via USB cable.',
    upgradeTestTwo: '2. Install and open the CZUR Scanner software on the computer.',
    upgradeTestThree: '3. Go to software Settings - Firmware Version - click Upgrade icon to upgrade firmware follow the software prompts.',
    upgradeTestFour: '4. Disconnect USB cable then scannner change to Wi-Fi mode, make sure ET connects to network successfully.Refresh CZUR app,you can use the cloud scan function.'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js